<template>
  <div id="app" v-bind:class="['vue-app', 'vue-page-' + $route.name ]">
    <!-- Always shows a header, even in smaller screens. -->
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
      <header v-if="top_menu" class="mdl-layout__header">
        <div class="mdl-layout__header-row">
          <!-- Title -->
          <span v-if="!($route.params.code  && isApiReport())" class="mdl-layout-title" :class="[$root.ui.isLoading() ? 'spinner' : '']" v-text="top_menu.title"></span>
          <span v-else class="mdl-layout-title" :class="[$root.ui.isLoading() ? 'spinner' : '']" v-text="translate('Nøytral takst fra') + ' Autotaksering AS'"></span>
          <template v-if="isReportPage()">
            <span class="mdl-layout-title report-language" v-if="report.report_language == 'no' && !($route.params.code && isApiReport())">- Norsk rapport</span>
              <span class="mdl-layout-title report-language" v-else-if="report.report_language == 'en' && !($route.params.code && isApiReport())">- Engelsk rapport</span>
            <span class="mdl-layout-title report-language" v-else-if="report.report_language == 'da' && !($route.params.code && isApiReport())">- Dansk rapport</span>
            <span class="mdl-layout-title report-language" v-else-if="report.report_language == 'sv' && !($route.params.code && isApiReport())">- Svensk rapport</span>
          </template>
          <!-- Add spacer, to align navigation to the right -->
          <div class="mdl-layout-spacer"></div>
          <!-- Navigation. We hide it in small screens. -->
          <nav v-if="!$root.isGuest()" class="mdl-navigation mdl-layout--large-screen-only">
            <template v-for="item in top_menu.items">
              <a class="mdl-navigation__link mdl-menu__item--full-bleed-divider" v-bind:href="item.link">
                <i class="material-icons" v-text="item.icon">assignment_ind</i>
                <span v-text="translate(item.title)"></span>
              </a>
            </template>
          </nav>
        </div>
      </header>
      <div v-if="!$root.isGuest() && left_menu" class="mdl-layout__drawer">
        <span v-if="left_menu.title" v-text="left_menu.title" class="mdl-layout-title"></span>
        <nav class="mdl-navigation">
          <template v-for="item in left_menu.items">
            <a @click="menuItemClick" class="mdl-navigation__link" v-bind:href="item.link">
              <i class="material-icons" v-text="item.icon">assignment_ind</i>
              <span v-text="translate(item.title)"></span>
            </a>
          </template>
          <a class="mdl-navigation__link"></a>
          <template v-for="item in left_menu.report_items">
            <a @click="menuItemClick" class="mdl-navigation__link" v-bind:href="item.link">
              <i class="material-icons" v-text="item.icon">assignment_ind</i>
              <span v-text="translate(item.title)"></span>
            </a>
          </template>
        </nav>
      </div>
      <div class="loadingMarker" v-if="$root.ui.isLoading('pageLoading')">
        <div class="cssload-thecube">
          <div class="cssload-cube cssload-c1"></div>
          <div class="cssload-cube cssload-c2"></div>
          <div class="cssload-cube cssload-c4"></div>
          <div class="cssload-cube cssload-c3"></div>
        </div>
      </div>
      <transition :duration="{ enter: 1000, leave: 0 }" name="pt">
        <router-view v-show="!$root.ui.isLoading('pageLoading')"></router-view>
      </transition>
    </div>
    <vue-easy-lightbox
            escDisabled
            moveDisabled
            :visible="$root.lightbox.visible"
            :imgs="$root.lightbox.imgs"
            :index="$root.lightbox.index"
            @hide="$root.closeLightbox"
    >
      <template slot="prev-btn" slot-scope="props">
        <div class="vel-shift-btn vel-prev" @click="$root.shiftLightboxImage(-1)"><i class="material-icons">navigate_before</i></div>
      </template>

      <template slot="next-btn" slot-scope="props">
        <div class="vel-shift-btn vel-next" @click="$root.shiftLightboxImage(1)"><i class="material-icons">navigate_next</i></div>
      </template>
      <template slot="toolbar" slot-scope="props">
        <div class="vel-toolbar">
          <button :disabled="$root.ui.isLoading('rotateImage')" class="toolbar-btn" @click="props.toolbarMethods.zoomIn"><i class="material-icons">zoom_in</i></button>
          <button :disabled="$root.ui.isLoading('rotateImage')" class="toolbar-btn" @click="props.toolbarMethods.zoomOut"><i class="material-icons">zoom_out</i></button>
          <button :disabled="$root.ui.isLoading('rotateImage')" class="toolbar-btn" @click="$root.rotateLightBoxImage(-90)"><i class="material-icons">rotate_right</i></button>
          <button :disabled="$root.ui.isLoading('rotateImage')" class="toolbar-btn" @click="$root.rotateLightBoxImage(90)"><i class="material-icons">rotate_left</i></button>
        </div>
      </template>
    </vue-easy-lightbox>
  </div>
</template>

<script>
  import reportValues from './mixins/reportValues.js'

  import VueEasyLightbox from 'vue-easy-lightbox'

  import 'vue2-datepicker/index.css';

  export default {
    name: 'app',
    data () {
      let left_menu_items = [{
          title: 'Arkiv',
          link: this.$router.resolve({ name: 'reports'}).href,
          icon: 'view_list'
      }];
      if(this.$root.isSurveyorCapability() || this.$root.isRental() || this.$root.isRentalCheckCapability() || this.$root.isEuropcarCapability() || this.$root.isAldCapability()){
          left_menu_items.unshift({
              title: 'Hjem',
              link: this.$router.resolve({ name: 'index'}).href,
              icon: 'home'
          });
          left_menu_items.push({
              title: 'Ny rapport',
              link: this.$router.resolve({ name: 'report-new'}).href,
              icon: 'add'
          });
      }
      if(this.$root.isUser()){
          left_menu_items.push({
              title: 'Min konto',
              link: this.$root.user.profile_url,
              icon: 'account_box'
          });
          if(this.$root.isEuropcarAdmin() || this.$root.isAldAdmin())
            left_menu_items.push({
                title: 'Brukere',
                link: this.$root.user.users_url,
                icon: 'person_add'
            });
          if(this.$root.isEuropcarAdmin() || this.$root.isAdministrator()){
              left_menu_items.push({
                  title: 'Avdelinger',
                  link: this.$router.resolve({ name: 'editor'}).href,
                  icon: 'business'
              });
              left_menu_items.push({
                  title: 'Ny avdeling',
                  link: this.$router.resolve({ name: 'new-department'}).href,
                  icon: 'add_business'
              });
          }
          left_menu_items.push({
              title: 'Logg ut',
              link: this.$root.user.logout_url,
              icon: 'logout'
          });
      }
      let top_menu_items = [{
          title: 'Arkiv',
          link: this.$router.resolve({ name: 'reports'}).href,
          icon: ''
      }];
      if(this.$root.isEuropcarAdmin() || this.$root.isAdministrator()){
          top_menu_items.unshift({
              title: 'Avdelinger',
              link: this.$router.resolve({ name: 'editor'}).href,
              icon: ''
          });
      }
      return {
        top_menu_items: top_menu_items,
        left_menu_items: left_menu_items
      }
    },
    components: {
        VueEasyLightbox
    },
    mixins: [reportValues],
    methods: {
      menuItemClick(){
        document.querySelector('.mdl-layout').MaterialLayout.toggleDrawer();
      }
    },
    computed: {
      top_menu(){
        return {
          title: this.top_menu_title,
          items: this.top_menu_items
        }
      },
      left_menu(){
        return {
          items: this.left_menu_items,
          report_items: this.report_items_menu
        }
      },
      top_menu_title(){
        if(['reports'].indexOf(this.$route.name) != -1)
          return 'Arkiv'
        if(this.report.contact_name && ['report-section','report-contact','report'].indexOf(this.$route.name) != -1)
          return (this.report.id_car ? this.report.id_car.toUpperCase() : '') + ' ' + this.report.contact_name
        return 'AUTOTAKST'
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// App.vue?7a096ab3